import { render, staticRenderFns } from "./uploadAlert.vue?vue&type=template&id=a158a9ae&lang=html&"
import script from "./uploadAlert.vue?vue&type=script&lang=js&"
export * from "./uploadAlert.vue?vue&type=script&lang=js&"
import style0 from "./uploadAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports